import type { CardFilter } from "../types";
import { CardFilterButton } from "./CardFilterButton";

type Props = {
  filter: CardFilter;
};

export const CardFilterView: React.FC<Props> = ({ filter }) => {
  const { options, value: selectedValue, onChange, largeView } = filter;

  return (
    <div className="bg-grey1 border-grey2 inline-flex gap-[3px] rounded-lg border p-[3px]">
      {options.map((option) => (
        <CardFilterButton
          key={option.key}
          option={option}
          isSelected={selectedValue === option.key}
          onSelectOption={onChange}
          largeView={largeView}
        />
      ))}
    </div>
  );
};
